
import React from 'react';
import LogoScroller from './LogoScroller';

const Partners = () => {
  return (
    <section id="partners" className="section bg-white text-darkText py-4">
      <div className="container mx-auto px-5 md:px-6">
        <LogoScroller />
      </div>
    </section>
  );
};

export default Partners;
